const DESKTOP_ZOOM_QUERY = "(hover: hover) and (pointer: fine) and (min-width: 768px)";
const ZOOM_CONTAINER_SELECTOR = "[main-gallery], .lightbox-slider";

class ProductGalleryZoomController {
  constructor(root = document) {
    this.mediaQuery = window.matchMedia(DESKTOP_ZOOM_QUERY);
    this.activeHolder = null;
    this.handlePointerMove = this.handlePointerMove.bind(this);
    this.handlePointerOut = this.handlePointerOut.bind(this);
    this.handleMediaChange = this.handleMediaChange.bind(this);

    if (typeof this.mediaQuery.addEventListener === "function") {
      this.mediaQuery.addEventListener("change", this.handleMediaChange);
    }

    this.mount(root);
  }

  mount(root = document) {
    const scope = root && typeof root.querySelectorAll === "function" ? root : document;
    Array.from(scope.querySelectorAll(ZOOM_CONTAINER_SELECTOR)).forEach((gallery) => this.bindGallery(gallery));
  }

  bindGallery(gallery) {
    if (!gallery || gallery.dataset.zoomBound === "true") return;
    gallery.dataset.zoomBound = "true";

    gallery.addEventListener("pointermove", (event) => this.handlePointerMove(event, gallery));
    gallery.addEventListener("pointerout", (event) => this.handlePointerOut(event, gallery));
  }

  handleMediaChange() {
    this.clearActive();
  }

  handlePointerMove(event, gallery) {
    if (event.pointerType !== "mouse" || !this.mediaQuery.matches) {
      this.clearActive();
      return;
    }

    const holder = event.target?.closest?.(".gallery-zoomable");
    if (!holder || !gallery.contains(holder)) {
      this.clearActive();
      return;
    }

    if (this.activeHolder && this.activeHolder !== holder) {
      this.clearActive();
    }

    const rect = holder.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    holder.style.setProperty("--zoom-origin-x", `${Math.min(100, Math.max(0, x))}%`);
    holder.style.setProperty("--zoom-origin-y", `${Math.min(100, Math.max(0, y))}%`);
    holder.classList.add("is-zooming");
    this.activeHolder = holder;
  }

  handlePointerOut(event, gallery) {
    const related = event.relatedTarget;
    if (related && gallery.contains(related)) return;
    this.clearActive();
  }

  clearActive() {
    if (!this.activeHolder) return;
    this.activeHolder.classList.remove("is-zooming");
    this.activeHolder.style.removeProperty("--zoom-origin-x");
    this.activeHolder.style.removeProperty("--zoom-origin-y");
    this.activeHolder = null;
  }
}

const bootstrap = (root = document) => {
  if (!root) return;
  if (!window.__quickfireGalleryZoom) {
    window.__quickfireGalleryZoom = new ProductGalleryZoomController(root);
  } else {
    window.__quickfireGalleryZoom.mount(root);
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => bootstrap());
} else {
  bootstrap();
}

document.addEventListener("shopify:section:load", (event) => {
  bootstrap(event?.target || document);
});

export { ProductGalleryZoomController };
